import { QF_VALUE } from 'config/constants';
import { GA } from 'types';
import jscookie from 'js-cookie';

export interface LoginData {
  type: GA.EventType.LOGIN;
  points?: string;
  method: GA.AuthMethod;
}

export interface LoginEvent {
  event: LoginData['type'];
  event_data: {
    action: GA.Action.LOGIN;
    method: GA.AuthMethod;
  };
  user?: {
    user_id: string;
    user_qff_hash: string;
    user_login_status: string;
    user_points: LoginData['points'];
  };
}

const getLoginEvent = (data: LoginData): LoginEvent => {
  const { type, points, method } = data;
  const event: LoginEvent = {
    event: type,
    event_data: {
      action: GA.Action.LOGIN,
      method,
    },
  };
  if (method === GA.AuthMethod.OAUTH) {
    const qffHash = jscookie.get(QF_VALUE) || '';

    event.user = {
      user_id: qffHash,
      user_qff_hash: qffHash,
      user_login_status: GA.UserLoginStatus.LOGGED_IN,
      user_points: points,
    };
  }

  return event;
};

export default getLoginEvent;
